import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useBusinessNumYwListQuery } from '../../store/ReactWebSiteApi';

function GetSalesman(props) {
    const [list,setList] = useState();
    const {data,isSuccess} =useBusinessNumYwListQuery({e_id:localStorage.getItem('e_id')})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {ebn_yw_id,ebn_yw_name,}=item;
                    return item = {value:ebn_yw_id,label:ebn_yw_name,}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        // console.log(f);
                        props.getSalesman(f.value,f.label,f.ed_id)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                />
            </Form.Item>
        </>
    )
}

export default GetSalesman